import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Button,
    Typography,
    Avatar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Tooltip,
    Chip,
    Stack,
    InputAdornment,
    TablePagination,
    Autocomplete,
    Menu,
    MenuItem
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import "../../styles/global.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {  GetAllSchool, GetAllSchoolOnboardingData } from "../../api/auth/authService";

import { GetAllGroup,PostGroup } from "../../api/auth/authService";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "../../components/SnackBar/SnackbarContext";
import * as Yup from 'yup';
import configAPI from "../../api/config";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import SchoolOnboardingDetailsModal from "./SchoolOnboardingDetailsModal";

const SchoolOnBoarding = () => {
     const { showSnackbar } = useSnackbar();

  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [selectedSchool, setSelectedSchool] = useState(null);
const [openSchoolModal, setOpenSchoolModal] = useState(false);
const [totalCount, setTotalCount] = useState(0);
   
const fetchOnboardingData = async (pageNumber = 1, pageSize = 10) => {
    try {
      setLoading(true);
      const payload = {
     pageNumber: pageNumber,
  pageSize: pageSize
    };


      const response = await GetAllSchoolOnboardingData(payload);

      if (response?.success) {
        const schoolArray = response?.data?.data;
        setSchools(Array.isArray(schoolArray) ? schoolArray : []);
        setTotalCount(response?.data?.totalRecords || 0);
      } else {
        setSchools([]);
      }
    } catch (error) {
        return "";
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
   fetchOnboardingData(page + 1, rowsPerPage);
}, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchOnboardingData(newPage + 1, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
  const newSize = parseInt(event.target.value, 10);
  setRowsPerPage(newSize);
  setPage(0);
  fetchOnboardingData(1, newSize);
};

  const filteredSchools = (schools || []).filter((school) =>
  school.schoolName?.toLowerCase().includes(searchTerm.toLowerCase())
);

  const handleSchoolClick = (school) => {
  setSelectedSchool(school);
  setOpenSchoolModal(true);
};
    return (
        <Box p={0}>
            <Box sx={{
                background: "#fff",
                borderRadius: 2,
                pt: 3,
                px: 3,
                pb: 1,
            }}>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "stretch", sm: "center" },
                        gap: 2,
                        p: 2,
                        mb: 2,
                        borderRadius: "8px",
                        background: "linear-gradient(135deg, #f5f9ff, #eef3ff)",
                        border: "1px solid #e0e7ff",
                    }}
                >
                    <Box >
                        <Typography
                            variant="h6"
                            fontWeight={700}
                            sx={{ color: "#1e3a8a", lineHeight: 1.2 }}
                        >
                            School OnBoarding List 
                        </Typography>

                        <Typography variant="caption" sx={{ color: "#64748b" }}>
                            Manage all School OnBoarding List
                        </Typography>

                    </Box>
                        <Box sx={{ mt: 1 }}>
                            <TextField
                                fullWidth
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                size="small"
                            />
                        </Box>

                </Box>
                {filteredSchools.length === 0 ? (
                    <Box
                        sx={{
                            textAlign: 'center',
                            py: 8,
                            border: '2px dashed #e0e0e0',
                            borderRadius: 2
                        }}
                    >
                        <Typography color="textSecondary" variant="h6" gutterBottom>
                            No School OnBoarding List Found
                        </Typography>
                    </Box>
                ) : (
                    <TableContainer sx={{ boxShadow: 'none', border: '1px solid #d7d0d0ff'}}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>S.No.</strong></TableCell>
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>OnBoarding No.</strong></TableCell>
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>School Name</strong></TableCell>
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>School Address</strong></TableCell>
                                    <TableCell sx={{minWidth:120,padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>OnBoarding Date</strong></TableCell>
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>OnBoarding Status</strong></TableCell>
                                  
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredSchools
                                    .map((school, index) => (
                                        <TableRow key={school.schoolID} hover>
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>
                                                {page * rowsPerPage + index + 1}
                                            </TableCell>
                                            
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>
                                        
                                            {school.onboardingCode || "—"}
                                        </TableCell>
                                            
                                    <TableCell>
                                        <Typography
                                            sx={{
                                            color: "primary.main",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                            fontWeight: 500,
                                            "&:hover": { color: "primary.dark" }
                                            }}
                                            onClick={() => handleSchoolClick(school)}
                                        >
                                            {school.schoolName}
                                        </Typography>
                                        </TableCell>
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>
                                        
                                            {school.address || "—"}
                                        </TableCell>
                                        <TableCell sx={{ padding: '8px', fontSize: '13px' }}>
                                        
                                            {school.onboardingDate
                                                                ? dayjs(school.onboardingDate).format("DD-MM-YYYY")
                                                                : "—"}
                                        </TableCell>
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>
                                        
                                            {school.status === true ? "Yes" : school.status === false ? "No" : "—"}
                                        </TableCell>


                                          
                                        </TableRow>
                                        
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                />
            </Box>

<SchoolOnboardingDetailsModal
  open={openSchoolModal}
  onClose={() => setOpenSchoolModal(false)}
  school={selectedSchool}
  onRefresh={fetchOnboardingData}
/>   
        </Box>
    );
};

export default SchoolOnBoarding;